module.exports = __webpack_public_path__ + "media/images/meeting_points/active-meeting-point-de8f13519a8aafd7b02e6711104df43c.png";